import React from "react";
import { Typography, Box } from "@material-ui/core";

export default function AssignStatusProgressComponent({
  lang,
  progress,
  status,
}) {
  return (
    <Box>
      <Typography
        variant="caption"
        style={{
          color:
            status === "failed"
              ? "#FDB022"
              : status === "success"
              ? "#32D583"
              : "#989898",
          textTransform: "capitalize",
        }}
      >
        {status === "failed"
          ? "Warning"
          : status === "success"
          ? "Success"
          : `${progress}%`}
      </Typography>
    </Box>
  );
}
